module.exports = __webpack_public_path__ + "img/rg_logo.f57a8c2e.svg";